module.exports = __webpack_public_path__ + "static/media/plan-acumula-300gb.121e24bd.svg";